var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryPendingProductsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.56 22.7401L32.21 21.1601C31.96 20.8601 31.75 20.3001 31.75 19.9001V18.2001C31.75 17.1401 30.88 16.2701 29.82 16.2701H28.12C27.72 16.2701 27.15 16.0601 26.85 15.8101L25.27 14.4601C24.58 13.8701 23.45 13.8701 22.76 14.4601L21.16 15.8101C20.86 16.0601 20.3 16.2701 19.9 16.2701H18.17C17.11 16.2701 16.24 17.1401 16.24 18.2001V19.9001C16.24 20.2901 16.04 20.8501 15.79 21.1501L14.44 22.7401C13.86 23.4401 13.86 24.5601 14.44 25.2401L15.79 26.8301C16.04 27.1201 16.24 27.6901 16.24 28.0801V29.7901C16.24 30.8501 17.11 31.7201 18.17 31.7201H19.91C20.3 31.7201 20.87 31.9301 21.17 32.1801L22.75 33.5301C23.44 34.1201 24.57 34.1201 25.26 33.5301L26.84 32.1801C27.14 31.9301 27.7 31.7201 28.1 31.7201H29.8C30.86 31.7201 31.73 30.8501 31.73 29.7901V28.0901C31.73 27.6901 31.94 27.1301 32.19 26.8301L33.54 25.2501C34.15 24.5701 34.15 23.4401 33.56 22.7401ZM23.25 20.1301C23.25 19.7201 23.59 19.3801 24 19.3801C24.41 19.3801 24.75 19.7201 24.75 20.1301V24.9601C24.75 25.3701 24.41 25.7101 24 25.7101C23.59 25.7101 23.25 25.3701 23.25 24.9601V20.1301ZM24 28.8701C23.45 28.8701 23 28.4201 23 27.8701C23 27.3201 23.44 26.8701 24 26.8701C24.55 26.8701 25 27.3201 25 27.8701C25 28.4201 24.56 28.8701 24 28.8701Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryPendingProductsCardIcon);
export default __webpack_public_path__ + "static/media/inventory-pending-products-card-icon.2519e41f6e1e4a8ca9f5dd9c88033f42.svg";
export { ForwardRef as ReactComponent };